// extracted by mini-css-extract-plugin
module.exports = {"root":"SaveButton-module__root___cb5qh","saveIcon":"SaveButton-module__saveIcon___2SY-L","saveIconSaved":"SaveButton-module__saveIconSaved___1z-sR"};